<template>
  <div v-if="props.data" class="orderlist-wrapper">
    <p v-if="props.data?.title" class="h4"> {{ props.data?.title }}</p>
    <ol class="orderlist-count">
      <li v-for="(item, i) in props?.data?.items" :key="i">
        <span>{{ item }}</span>
      </li>
    </ol>
  </div>
</template>


<script lang="ts">
import { defineComponent } from "vue";


export default defineComponent({
  name: "OrderList",
  components: {},
  props: {
    data: {}
  },
  setup(props) {
    return {
      props
    };
  }
});

</script>

<style lang="scss" scoped>
.orderlist-wrapper {
  padding: 16px 16px;
  border-radius: 8px;
  background-color: rgba(230, 238, 247, 0.5);
  max-width: 540px;
}

.orderlist-count {
  margin: 0 auto;
  display: inline-block;
  $connectionColor: var(--spsm-blue-1);


  li {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0.6rem 0;
    counter-increment: li;
    list-style: none;

    &:before {
      content: counter(li) " ";
      position: relative;
      z-index: 10;
      width: 2.4rem;
      height: 2.4rem;
      min-width: 2.4rem;
      min-height: 2.4rem;
      margin-right: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      background: $connectionColor;
      color: #fff;
    }

    + li {
      &:after {
        content: '';
        position: absolute;
        z-index: 0;
        left: 18px;
        top: -2rem;
        right: auto;
        width: 2px;
        height: 3.4rem;
        background: $connectionColor;
      }
    }

  }
}
</style>